import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Widget } from '~/components/MyWorkspace/Widget';

import { WidgetProps } from '../../data/widgets';

import { MyDataWidgetContent } from './components/Content';
import { useSxStyles } from './useStyles';

export interface Props extends WidgetProps {}

export const MyDataWidget: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Widget
      title={title || t('myData')}
      content={<MyDataWidgetContent />}
      customSxStyles={{ content: sxStyles.root }}
      dataCy="my-data-widget"
    />
  );
};
